<template>
  <div>
    <input v-model.trim="search" ref="search" type="text" :placeholder="$t('purchaseOrder.searchProductList')"
      class="form-control" />
    <div class="ts-mt-3 ts-border ts-border-gray-300 ts-p-3 ts-rounded">
      <ts-loading-banner>
        <div class="max-h">
          <table class="ts-w-full">
            <thead>
              <tr>
                <th style="width: 13%;">
                  {{ $t('productPriceSchema.productGroup') }}
                </th>
                <th style="width: 13%;">
                  {{ $t('productPriceSchema.barcode') }}
                </th>
                <th style="width: 24%;">
                  {{ $t('productPriceSchema.productName') }}
                </th>
                <th style="width: 13%;">
                  {{ $t('productPriceSchema.uom') }}
                </th>
                <th style="width: 20%;">
                  {{ $t('productPriceSchema.unitPrice') }}
                </th>
                <th style="width: 4%;"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(product, index) in products" :key="index">
                <td>{{ product.pro_group_name_en }}</td>
                <td>{{ product.barcode }}</td>
                <td>{{ product.product_name_en }}</td>
                <td>
                  <a-select v-model="product.uom_id" :options="getUnitOfMeasures(product.uom_cat_id)"
                    option-filter-prop="children" class="ts-w-full" placeholder="Select"
                    @change="onUomChange(product)"></a-select>
                </td>
                <td class="ts-text-right">
                  <ts-currency-input type="text" v-model="product.sale_price" currency="$" class="
                ts-w-full ts-border ts-rounded ts-py-1 ts-text-right ts-px-2 ts-h-8" disabled />
                </td>
                <td class="ts-text-center ts-cursor-pointer">
                  <a href="#" class="ts-text-blue-500" @click.prevent="addItem(product)">
                    <i class="fa fa-plus"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ts-loading-banner>
    </div>
    <small>
      <i>{{ $t('purchaseOrder.clickToAddProduct') }}</i>
    </small>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { includes } from 'lodash'

export default {
  name: 'productList',
  props: ['value'],
  data() {
    return {
      search: '',
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    ...mapState('restaurantSale/productPriceSchema', ['formViewDatas']),
    products() {
      if (this.formViewDatas['products']) {
        return this.formViewDatas['products']
          .filter(
            p =>
              !includes(
                this.model.product_list.map(el => el.product_id),
                p.product_id
              )
          )
          .filter(
            ei =>
              this.search
                .split(' ')
                .every(s =>
                  ei.barcode.toLowerCase().includes(s.toLowerCase())
                ) ||
              this.search
                .split(' ')
                .every(s =>
                  ei.product_name_en.toLowerCase().includes(s.toLowerCase())
                )
          )
          .slice(0, 20)
      }
      return []
    },
    unitOfMeasures() {
      if (this.formViewDatas['unitOfMeasures']) {
        return this.formViewDatas['unitOfMeasures']
          .map(el => ({
            value: el.uom_id,
            label: el.uom_name_en,
            uom_cat_id: el.uom_cat_id,
            is_default: el.is_default,
            stockout_quantity: el.stockout_quantity
          }))
      }
      return []
    }
  },
  methods: {
    getUnitOfMeasures(uom_cat_id) {
      return this.unitOfMeasures.filter(el => el.uom_cat_id == uom_cat_id)
    },
    onUomChange(product) {
      const price = product.sale_code.find(el => el.uom_id == product.uom_id)
      product.sale_price = price ? price.sale_price : 0
    },
    addItem(product) {
      let row = {
        guest_level_id: this.model.guest_level_id,
        product_id: product.product_id,
        uom_cat_id: product.uom_cat_id,
        uom_id: product.uom_id,
        increment_amount: this.model.increment_amount,
        increment_type: this.model.increment_type,
        max_person: 0,
        service_length: null,
        sale_price: product.sale_price,
      }

      this.model.product_list.push(row)
    }
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style scoped>
.max-h {
  min-height: 60vh;
  max-height: 60vh;
  overflow-y: scroll;
}

.form-control {
  height: 32px;
}

table {
  width: 100%;
}

table thead tr {
  border-width: 1px;
  z-index: 3;
  position: sticky;
  top: 0;
  /* Don't forget this, required for the stickiness */
}

table thead tr th {
  white-space: nowrap;
  background-color: #edf2f7;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

table tbody tr {
  cursor: pointer;
  border-width: 1px;
}

table tbody tr:hover {
  background-color: #e2e8f0;
}

table tbody tr td {
  white-space: nowrap;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  border-right-width: 1px;
}
</style>
